import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { RadioGroupWithLabel } from "./RadioGroup";
import CustomTextField from "./CustomTextField";
import { MAX_VALUE_CONSTRAINTS, MIN_VALUE } from "./constants";
import Collapse from "@material-ui/core/Collapse";
import { inject, observer } from "mobx-react";
const styles = (theme) => ({
  flexRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  infoText: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    opacity: 0.8,
  },
  fixedWidthField: { 
    width:"130px",
    flexGrow:0 
  },
  detailsColumnWise: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
  },
  rowDescription: {
    display: "flex",
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    marginTop: 8,
    fontWeight: 500,
  },
  rowDropdowns:{
    display:"flex",
    alignItems:"flex-start",
    gap:"14px"
  },
  errorMessage:{
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
  }
});

const ExcessiveLength = ({
  data,
  handleExcessiveLengthFeetChange,
  handleExcessiveLengthInchesChange,
  handleIsExcessiveLengthChange,
  excessiveLengthError,
  classes,
  maxAllowedTrailerLength,
  rowLabel,
  rowDescription,
  collapseOpen,
  options,
  customClasses,
  DispatchStore
  }) => {
    
  const maxExcessiveLength = DispatchStore.getExcessiveLengthMaxLimit(maxAllowedTrailerLength)
  return (
    <>
      <RadioGroupWithLabel
        rowLabel={rowLabel || "EXCESSIVE LENGTH"}
        rowDescription={rowDescription}
        onChange={handleIsExcessiveLengthChange}
        options={options}
        value={data.isExcessiveLength}
        customClasses={{ ...classes, ...customClasses }}
      />
      <Collapse
        in={collapseOpen}
        timeout="auto"
        unmountOnExit
        >
        <div className={classes.rowDropdowns}>
          <CustomTextField
            className={classes.fixedWidthField}
            id="excessiveLengthFeet"
            handleChange={handleExcessiveLengthFeetChange}
            value={data.excessiveLengthValue.feet}
            error={Boolean(excessiveLengthError)}
            label={`Feet (${MIN_VALUE.EXCESSIVE_LENGTH.FEET} - ${maxExcessiveLength})`}
            inputProps={{
              focus: true,
              min: MIN_VALUE.EXCESSIVE_LENGTH.FEET,
              max: maxExcessiveLength
            }}
            type="number"
          />
          <CustomTextField
            className={classes.fixedWidthField}
            id="excessiveLengthInches"
            handleChange={handleExcessiveLengthInchesChange}
            value={data.excessiveLengthValue.inches}
            error={Boolean(excessiveLengthError)}
            label={`Inches (${MIN_VALUE.EXCESSIVE_LENGTH.INCHES} - ${MAX_VALUE_CONSTRAINTS.EXCESSIVE_LENGTH.INCHES})`}
            inputProps={{
              min: MIN_VALUE.EXCESSIVE_LENGTH.INCHES,
              max: MAX_VALUE_CONSTRAINTS.EXCESSIVE_LENGTH.INCHES
            }}
            type="number"
          />
        </div>

        {!excessiveLengthError ? (
          <span className={classes.infoText}>
            {`Pro must be 8 feet (or) less than or equal to ${maxExcessiveLength} feet.`}
          </span>
        ) : (
          <span className={classes.errorMessage}>{excessiveLengthError}</span>
        )}
      </Collapse>
    </>
  );
};

export default inject('DispatchStore')(observer(withStyles(styles)(ExcessiveLength)));
